import { render, staticRenderFns } from "./RegistrationSelf.vue?vue&type=template&id=05c07a55&"
import script from "./RegistrationSelf.vue?vue&type=script&lang=ts&"
export * from "./RegistrationSelf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports